jQuery(function ($) {
	const base = "gc-navbar";

	$(`.${base}__burger`).on("click", function () {
		$(`.${base}`).toggleClass(`${base}--active`);
	});

	$(window).on("resize", function () {
		if ($(window).width() >= 900) {
			$(`.${base}`).removeClass(`${base}--active`);
		}
	});

	if (window.location.hash) {
		makeNavbarSticky(false);
	}

	$(window).on("scroll", () => makeNavbarSticky(true));

	function makeNavbarSticky(transition) {
		if ($(window).scrollTop() >= 180) {
			$(`.gp-base__header`).css("padding-top", $(`.${base}`).height());
			$(`.${base}`).addClass(`${base}--sticky`);
		} else {
			$(`.gp-base__header`).css("padding-top", 0);
			$(`.${base}`).removeClass(`${base}--sticky`);

			if (transition) {
				$(`.${base}`).css("transition", "");
			}
		}

		if ($(window).scrollTop() >= 300) {
			if (transition) {
				$(`.${base}`).css("transition", "0.3s ease-in-out");
			}
			$(`.${base}`).addClass(`${base}--sticky-show`);
		} else {
			$(`.${base}`).removeClass(`${base}--sticky-show`);
		}
	}
});
